import * as React from 'react';
import styled, { keyframes, withTheme } from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import { StyledTableRow } from '../../Product/ProductTabRowTable';
import { ZemplinLoaderWrapper } from '../../../..';
import { TableWrapper } from '../../General/TableWrapper';
import { FlexRow } from '../../../Defaults/Flexbox/Flexbox';
import { RequestTabRow } from './RequestTabRow';
import { TableTh, TableTd } from '../../General/Table';
import { RequestTabRowMobile } from './RequestTabRowMobile';
import { ItemsTabRowMobile } from './ItemsTabRowMobile';
import { ItemsTabRow } from './ItemsTabRow';
import { IconType, SvgIcon } from '../../General/SvgIcon';
import { isOrderingLessThanMinimum } from '../../selectors';

interface Props {
  products: any;
  addToCart: any;
  removeFromCart: any;
  visible?: boolean;
  theme: any;
  refreshCart: () => void;
  isB2B: boolean;
}

function ItemsProductTable({
  products,
  addToCart,
  removeFromCart,
  visible = true,
  theme,
  refreshCart,
  isB2B,
}: Props) {
  const COLUMNS = [
    { name: 'Produkt' },
    {
      name: isB2B ? __('Cena bez DPH') : __('Cena s DPH'),
      align: 'right',
    },
    { name: 'Množstvo', align: 'center' },
    { name: 'Balenie' },
    { name: isB2B ? __('Spolu bez DPH') : __('Spolu s DPH') },
    { name: '', icon: 'refresh', align: 'right' },
  ];

  const productsComponent =
    products &&
    products.map((p: any, i) => {
      return (
        <ItemsTabRow
          key={p.product.product_id}
          hasBottomBorder={!isOrderingLessThanMinimum(p)}
          addToCart={addToCart}
          removeFromCart={removeFromCart}
          product={p}
          isB2B={isB2B}
          lessThanMinimum={isOrderingLessThanMinimum(p)}
        />
      );
    });

  const mobileProductsComponent =
    products &&
    products.map((p: any, i) => {
      return (
        <React.Fragment key={p.product.product_id}>
          <StyledTableRow>
            <ItemsTabRowMobile
              addToCart={addToCart}
              removeFromCart={removeFromCart}
              product={p}
              hasMinAmountInfo={isOrderingLessThanMinimum(p)}
              isB2B={isB2B}
            />
          </StyledTableRow>
        </React.Fragment>
      );
    });

  const headers =
    COLUMNS &&
    COLUMNS.map((item: any, i) =>
      item.icon ? (
        <StyledTableTh
          style={{ paddingRight: '8px' }}
          align={item.align || 'left'}
          key={i}
        >
          <SvgIcon
            cursor={'pointer'}
            width={24}
            height={24}
            onClick={refreshCart}
            icon={IconType[item.icon]}
            alt="Aktualizovať"
            title="Aktualizovať"
            fill={theme.colors.textPrimary}
          />
        </StyledTableTh>
      ) : (
        <StyledTableTh
          width={item.width}
          minWidth={item.minWidth}
          align={item.align || 'left'}
          key={i}
        >
          {item.name}
          {item.name === 'Balenie' && <p style={{ margin: 0 }}>({'kartón'})</p>}
        </StyledTableTh>
      ),
    );

  return (
    <Wrapper visible={visible}>
      <DesktopListProductsWrapper>
        <TableWrapper
          noItemsText={__('Nenašli sa produkty')}
          headers={headers}
          rows={productsComponent}
        />
      </DesktopListProductsWrapper>
      <MobileListProductsWrapper>
        {mobileProductsComponent}
      </MobileListProductsWrapper>
    </Wrapper>
  );
}

const animateIn = keyframes`
   0% {
    opacity: 0;
    transform: scale(0.6) translateY(-8px);
  }
  
  100% {
    opacity: 1;
  }
`;

const Wrapper = styled(FlexRow)<{ visible: boolean }>`
  flex-flow: row wrap;
  margin-bottom: ${({ visible }) => (visible ? rem(56) : 0)};
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  animation: ${animateIn} 0.2s ease;

  ${({ theme }) => theme.mediab.m810`
     margin-bottom: 0;
  `}
`;

const DesktopListProductsWrapper = styled.div`
  display: block;
  width: 100%;

  ${({ theme }) => theme.mediab.m810`
    display: none;
  `}
`;

const MobileListProductsWrapper = styled.div`
  display: none;
  width: 100%;

  ${({ theme }) => theme.mediab.m810`
      margin-bottom: ${rem(56)};
      display: flex;
      justify-content: center;
      flex-flow: column;
  `}
`;

const StyledTableTh = styled(TableTh)`
  padding-bottom: ${rem(24)};
`;

const InfoTableTd = styled(TableTd)``;

const WithTheme: any = withTheme(ItemsProductTable);
export { WithTheme as ItemsProductTable };
